<template>
  <div id="app" class="u-bg--white">
    <router-view />
  </div>
</template>
<script>
export default {
  name: 'SeoDesktop',
};
</script>
